import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ScrollViewComponent } from './scroll-view.component';

@NgModule({
  imports: [CommonModule],
  declarations: [ScrollViewComponent],
  exports: [ScrollViewComponent],
})
export class ScrollViewModule {}
